export default __webpack_public_path__ + "static/media/image.0ba78fb1.jpeg";